// src/app/services/admin-id.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { authService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AdminIdGuard implements CanActivate {
  // Add your allowed user IDs here
  private readonly allowedIds: number[] = [
    1,
    64035
  ];

  constructor(
    private authService: authService,
    private router: Router
  ) {}

  canActivate(): boolean {
    const currentUser = this.authService.getCurrentUser();
    
    if (currentUser && this.allowedIds.includes(currentUser.id)) {
      return true;
    }
    
    this.router.navigate(['/admissions/dashboard']);
    return false;
  }
}